<div class="modal-body" style="background: linear-gradient(to bottom right, #c59f385f, #FFFFFF); padding: 20px;">
    <div class="text-center pt-3 pb-2">
      <div 
        [ngStyle]="{color: isCritical ? '#FF5733' : '#C59F38'}"
        style="font-size: 3rem"
      >
        <span class="iconify" data-icon="mdi:timer-sand"></span>
      </div>
      <div class="mt-3 fw-medium" style="color: #333;">{{ body }}</div>
      <div 
        class="fw-semibold fs-1" 
        style="margin: 2rem 0rem;" 
        [ngStyle]="{color: isCritical ? 'red' : 'initial'}"
      >
        {{ displayMinutes }}:{{ displaySeconds }}
      </div>
      <div *ngIf="loading" class="d-flex align-items-center justify-content-center">
        <i class="fa fa-spinner fa-spin" style="font-size: 30px; color: #FF5733;"></i>
      </div>
      <div *ngIf="!loading" class="d-flex align-items-center justify-content-between gap-4">
        <button 
          (click)="exit()" 
          type="button" 
          class="btn btn-outline-danger w-100"
          style="white-space: nowrap;"
        >{{ negativeButtonText }}</button>
        <button 
          (click)="refresh()" 
          type="button" 
          class="btn w-100 text-white" 
          style="background-color: #C59F38; border-color: #C59F38; white-space: nowrap;"
        >{{ positiveButtonText }}</button>
      </div>
    </div>
  </div>
  